module.exports = __webpack_public_path__ + "img/22-ContenidouHaven.5173038c.jpg";